
import { CouponsInfo } from '@/modules/aftersales/types/carInfo'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { couponType } from './helper'

@Component({})
export default class ViewCouponInfo extends Vue {
  @Prop({ type: Object, required: true }) couponsInfo!: CouponsInfo;

  get cachedCouponType() {
    return couponType
  }

  get couponStats() {
    const {
      total_gift_cards,
      total_coupons,
      total_coupon_packages
    } = this.couponsInfo.stats

    return [
      `卡:${total_gift_cards}张`,
      `券:${total_coupons}张`,
      `包:${total_coupon_packages}个`
    ].join(' / ')
  }
}
